import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeleteTeachingArea($id: Int!) {
    deleteTeachingArea(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteTeachingArea: {
    id?: number;
  };
}
